import createAccessibeScript from "./accessibe";

export function setupScripts() {
  setupAccessibe();
}

function setupAccessibe() {
  var head = document.getElementsByTagName("head")[0];
  var accessibeScript = document.createElement("script");
  var inlineScript = document.createTextNode(createAccessibeScript());
  accessibeScript.appendChild(inlineScript);
  head.appendChild(accessibeScript);
}
